/**
 * Allowed support ticket attachment file extensions.
 */
export const ALLOWED_ATTACHMENT_TYPES = [
  ".pdf",
  ".doc",
  ".docx",
  ".xls",
  ".xlsx",
  ".jpg",
  ".jpeg",
  ".png",
];

/** Maximum allowed attachment size (10 MB). */
export const MAX_ATTACHMENT_SIZE_BYTES = 10 * 1024 * 1024;

/** `accept` attribute value for the attachment file input. */
export const ATTACHMENT_ACCEPT =
  ".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,image/jpeg,image/png";

/** Human-readable list of supported formats for helper/toast copy. */
export const SUPPORTED_ATTACHMENT_COPY =
  "PDF, Word, Excel, JPG, PNG up to 10MB";

/**
 * Validates a support ticket attachment before upload.
 *
 * @param file - Selected file from a picker or drag-and-drop area.
 * @returns True when the file type and size are allowed.
 */
export function isValidSupportTicketAttachment(file: File): boolean {
  const extension = file.name
    .substring(file.name.lastIndexOf("."))
    .toLowerCase();
  const isAllowedType = ALLOWED_ATTACHMENT_TYPES.includes(extension);
  const isAllowedSize = file.size <= MAX_ATTACHMENT_SIZE_BYTES;

  return isAllowedType && isAllowedSize;
}
